// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_DASHBOARD = {
  telefonia: {
    index: {
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_tel_nac_sal_serv &&
          (user?.cliente?.modulos_permisos?.rep_modulo_gral ||
            user?.cliente?.modulos_permisos?.adm_modulo_gral ||
            user?.cliente?.modulos_permisos?.gra_modulo_gral)
        );
      },
    },
    reportes: {
      index: {
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral
          );
        },
      },
      llamadas_contestadas: {
        path: '/telefonia/reportes/llamadas-contestadas',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_calls_v &&
            user?.cliente?.modulos_permisos?.rep_calls_gral
          );
        },
      },
      llamadas_fallidas: {
        path: '/telefonia/reportes/llamadas-fallidas',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_calls_fail_v &&
            user?.cliente?.modulos_permisos?.rep_calls_fail_gral
          );
        },
      },
      llamadas_bloqueadas: {
        path: '/telefonia/reportes/llamadas-bloqueadas',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_calls_bloq_v &&
            user?.cliente?.modulos_permisos?.rep_calls_bloq_gral
          );
        },
      },
      resumen_por_fecha: {
        path: '/telefonia/reportes/resumen-por-fecha',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_por_fecha_v &&
            user?.cliente?.modulos_permisos?.rep_por_fecha_gral
          );
        },
      },
      resumen_prefijos: {
        path: '/telefonia/reportes/resumen-prefijos',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_prefijos_v &&
            user?.cliente?.modulos_permisos?.rep_prefijos_gral
          );
        },
      },
      resumen_ip: {
        path: '/telefonia/reportes/resumen-ip',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_ip_v &&
            user?.cliente?.modulos_permisos?.rep_ip_gral
          );
        },
      },
      informe_bloqueos: {
        path: '/telefonia/reportes/informe-bloqueos',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_rep_bloq_v &&
            user?.cliente?.modulos_permisos?.rep_rep_bloq_gral
          );
        },
      },
      cdr: {
        path: '/telefonia/reportes/cdr',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_modulo &&
            user?.cliente?.modulos_permisos?.rep_modulo_gral &&
            user?.modulos_cliente?.rep_cdr_v &&
            user?.cliente?.modulos_permisos?.rep_cdr_gral
          );
        },
      },
    },
    administracion: {
      index: {
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.adm_modulo &&
            user?.cliente?.modulos_permisos?.adm_modulo_gral
          );
        },
      },
      csv_bloqueos: {
        path: '/telefonia/administracion/csv-bloqueos',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.adm_modulo &&
            user?.cliente?.modulos_permisos?.adm_modulo_gral &&
            user?.modulos_cliente?.adm_bloq_v &&
            user?.cliente?.modulos_permisos?.adm_bloq_gral
          );
        },
      },
      numeros_bloqueados: {
        path: '/telefonia/administracion/numeros-bloqueados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.adm_modulo &&
            user?.cliente?.modulos_permisos?.adm_modulo_gral &&
            user?.modulos_cliente?.adm_num_bloq_v &&
            user?.cliente?.modulos_permisos?.adm_num_bloq_gral
          );
        },
      },
      historial_bloqueos: {
        path: '/telefonia/administracion/historial-bloqueos',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.adm_modulo &&
            user?.cliente?.modulos_permisos?.adm_modulo_gral &&
            user?.modulos_cliente?.adm_hist_bloq_v &&
            user?.cliente?.modulos_permisos?.adm_hist_bloq_gral
          );
        },
      },
      ani: {
        path: '/telefonia/administracion/ani',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.adm_modulo &&
            user?.cliente?.modulos_permisos?.adm_modulo_gral &&
            user?.cliente?.modulos_permisos?.adm_ani_gral &&
            user?.modulos_cliente?.adm_ani_v
          );
        },
      },
    },
    graficos: {
      index: {
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.gra_modulo &&
            user?.cliente?.modulos_permisos?.gra_modulo_gral
          );
        },
      },
      minutos_utilizados: {
        path: '/telefonia/graficos/minutos-utilizados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.gra_modulo &&
            user?.cliente?.modulos_permisos?.gra_modulo_gral &&
            user?.modulos_cliente?.gra_min_util_v &&
            user?.cliente?.modulos_permisos?.gra_min_util_gral
          );
        },
      },
    },
  },
  sms: {
    index: {
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_sms_serv &&
          (user?.cliente?.modulos_permisos?.rep_sms_modulo_gral ||
            user?.cliente?.modulos_permisos?.env_sms_simple_gral ||
            user?.cliente?.modulos_permisos?.env_sms_masivo_gral)
        );
      },
    },
    envio_individual: {
      path: '/sms/envio-individual',
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_sms_serv &&
          (user?.cliente?.modulos_permisos?.rep_sms_modulo_gral ||
            user?.cliente?.modulos_permisos?.env_sms_simple_gral ||
            user?.cliente?.modulos_permisos?.env_sms_masivo_gral) &&
          user?.modulos_cliente?.env_sms_simple_v &&
          user?.cliente?.modulos_permisos?.env_sms_simple_gral
        );
      },
    },
    envio_masivo: {
      path: '/sms/envio-masivo',
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_sms_serv &&
          user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
          user?.cliente?.modulos_permisos?.env_sms_simple_gral &&
          user?.cliente?.modulos_permisos?.env_sms_masivo_gral &&
          user?.modulos_cliente?.env_sms_masivo_v &&
          user?.cliente?.modulos_permisos?.env_sms_masivo_gral
        );
      },
    },
    reportes: {
      index: {
        renderCondition: (user) => {
          return (
            user?.cliente?.clie_sms_serv &&
            (user?.cliente?.modulos_permisos?.rep_sms_modulo_gral ||
              user?.cliente?.modulos_permisos?.env_sms_simple_gral ||
              user?.cliente?.modulos_permisos?.env_sms_masivo_gral) &&
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral
          );
        },
      },
      estado_de_envios: {
        path: '/sms/reportes/estado-de-envios',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
            user?.modulos_cliente?.rep_sms_status_env_v &&
            user?.cliente?.modulos_permisos?.rep_sms_status_env_gral
          );
        },
      },
      resumen_por_dia: {
        path: '/sms/reportes/resumen-por-dia',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
            user?.modulos_cliente?.rep_sms_por_dia_v &&
            user?.cliente?.modulos_permisos?.rep_sms_por_dia_gral
          );
        },
      },
      resumen_de_enviados: {
        path: '/sms/reportes/resumen-de-enviados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
            user?.modulos_cliente?.rep_sms_por_fecha_v &&
            user?.cliente?.modulos_permisos?.rep_sms_por_fecha_gral
          );
        },
      },
      sms_enviados: {
        path: '/sms/reportes/sms-enviados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
            user?.modulos_cliente?.rep_sms_env_v &&
            user?.cliente?.modulos_permisos?.rep_sms_env_gral
          );
        },
      },
      sms_recibidos: {
        path: '/sms/reportes/sms-recibidos',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_modulo &&
            user?.cliente?.modulos_permisos?.rep_sms_modulo_gral &&
            user?.modulos_cliente?.rep_sms_rec_v &&
            user?.cliente?.modulos_permisos?.rep_sms_rec_gral
          );
        },
      },
    },
  },
  sms_ng: {
    index: {
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_sms_ng_serv &&
          (user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral ||
            user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral ||
            user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral)
        );
      },
    },
    envio_individual: {
      path: '/sms-ng/envio-individual',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.env_sms_sim_ng_v &&
          user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral
        );
      },
    },
    envio_masivo: {
      path: '/sms-ng/envio-masivo',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.env_sms_mas_ng_v &&
          user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral
        );
      },
    },
    api_sms: {
      path: '/sms-ng/api-sms',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.api_doc_sms_ng_v &&
          user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral
          /*user?.modulos_cliente?.status_sms_ng_v */
        );
      },
    },
    estado_campana: {
      path: '/sms-ng/estado-campana',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.status_sms_ng_v &&
          user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral
          /*user?.modulos_cliente?.status_sms_ng_v */
        );
      },
    },
    reportes: {
      index: {
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral
          );
        },
      },
      estados_salientes: {
        path: '/sms-ng/reportes/estados-salientes',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_status_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_status_ng_gral
          );
        },
      },
      sms_asociados: {
        path: '/sms-ng/reportes/sms-asociados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_env_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_env_ng_gral &&
            user?.cliente?.asociaciones_tarifas_sms_ng > 0
          );
        },
      },
      sms_salientes: {
        path: '/sms-ng/reportes/sms-salientes',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_env_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_env_ng_gral &&
            user?.cliente?.asociaciones_tarifas_sms_ng === 0
          );
        },
      },
      sms_entrantes: {
        path: '/sms-ng/reportes/sms-entrantes',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_rec_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_rec_ng_gral
          );
        },
      },
      resumen_por_fecha: {
        path: '/sms-ng/reportes/resumen-por-fecha',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_dia_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_dia_ng_gral
          );
        },
      },
      exportar_salientes: {
        path: '/sms-ng/reportes/exportar-salientes',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_fecha_sal_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_fecha_sal_ng_gral &&
            user?.cliente?.asociaciones_tarifas_sms_ng === 0
          );
        },
      },
      exportar_asociados: {
        path: '/sms-ng/reportes/exportar-asociados',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_fecha_sal_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_fecha_sal_ng_gral &&
            user?.cliente?.asociaciones_tarifas_sms_ng > 0
          );
        },
      },
      exportar_entrantes: {
        path: '/sms-ng/reportes/exportar-entrantes',
        renderCondition: (user) => {
          return (
            user?.modulos_cliente?.rep_sms_ng_mod &&
            user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral &&
            user?.modulos_cliente?.rep_sms_fecha_ent_ng_v &&
            user?.cliente?.modulos_permisos?.rep_sms_fecha_ent_ng_gral
          );
        },
      },
    },
  },
  api_sms_ng: {
    index: {
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_sms_ng_serv ||
          user?.cliente?.modulos_permisos?.rep_sms_mod_ng_gral ||
          user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral ||
          user?.cliente?.modulos_permisos?.env_sms_mas_ng_gral
        );
      },
    },
    simple: {
      path: '/api-sms-ng/simple',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.env_sms_sim_ng_v &&
          user?.cliente?.modulos_permisos?.env_sms_sim_ng_gral
        );
      },
    },
  },
  tickets: {
    index: {
      renderCondition: (user) => {
        return user?.cliente?.modulos_permisos?.tick_modulo_gral;
        //cliente?.tick_modulo NO lo encuentro!
        /* user?.cliente?.tick_modulo &&
          user?.cliente?.modulos_permisos?.tick_modulo_gral */
      },
    },
    requerimientos: {
      path: '/tickets/requerimientos',
      renderCondition: (user) => {
        return (
          user?.cliente?.modulos_permisos?.tick_modulo_gral &&
          user?.modulos_cliente?.tick_req_v &&
          user?.cliente?.modulos_permisos?.tick_req_gral
        );
      },
    },
    incidentes: {
      path: '/tickets/incidentes',
      renderCondition: (user) => {
        return (
          user?.cliente?.modulos_permisos?.tick_modulo_gral &&
          user?.modulos_cliente?.tick_inc_v &&
          user?.cliente?.modulos_permisos?.tick_inc_gral
        );
      },
    },
  },
  maquinas_virtuales: {
    index: {
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_mv_serv &&
          user?.cliente?.modulos_permisos?.mv_modulo_gral
        );
      },
    },
    listar: {
      path: '/maquinas-virtuales/listar',
      renderCondition: (user) => {
        return (
          user?.cliente?.clie_mv_serv &&
          user?.cliente?.modulos_permisos?.mv_modulo_gral &&
          user?.modulos_cliente?.mv_list_v &&
          user?.cliente?.modulos_permisos?.mv_list_gral
        );
      },
    },
  },
  configuraciones: {
    index: {
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.cnf_modulo &&
          user?.cliente?.modulos_permisos?.cnf_usua_gral
        );
      },
    },
    usuarios: {
      path: '/configuraciones/usuarios',
      renderCondition: (user) => {
        return (
          user?.modulos_cliente?.cnf_modulo &&
          user?.cliente?.modulos_permisos?.cnf_usua_gral &&
          user?.modulos_cliente?.cnf_usua_v
        );
      },
    },
  },
  perfil: {
    path: '/perfil',
    renderCondition: (user) => {
      return true;
    },
  },

  logs: {
    index: {
      renderCondition: (user) => {
        return (
          user.cliente?.modulos_permisos?.hist_modulo_gral &&
          user.cliente?.modulos_permisos?.hist_action_gral &&
          user?.modulos_cliente?.hist_modulo
        );
      },
    },
    detalle: {
      path: '/logs/reporte',
      renderCondition: (user) => {
        return (
          user.cliente?.modulos_permisos?.hist_modulo_gral &&
          user.cliente?.modulos_permisos?.hist_action_gral &&
          user?.modulos_cliente?.hist_modulo &&
          user?.modulos_cliente?.hist_action_v
        );
      },
    },
  },
};
